module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv4-cf3c3b689189b234683775e1f73c21a9.jpg";